import assistantAvatar from "@/assets/mcp/assistant-avatar.png";

const USER_HEAD =
  "M7.38158 8.88158C9.31458 8.88158 10.8816 7.09072 10.8816 4.88158C10.8816 2.67244 9.31458 0.881579 7.38158 0.881579C5.44858 0.881579 3.88158 2.67244 3.88158 4.88158C3.88158 7.09072 5.44858 8.88158 7.38158 8.88158Z";
const USER_BODY =
  "M11.1025 9.88158H11.3644C11.9085 9.88173 12.4338 10.0821 12.8416 10.445C13.2494 10.808 13.5117 11.3085 13.5791 11.8526L13.8701 14.1956C13.8963 14.4067 13.8776 14.6209 13.8153 14.8242C13.753 15.0274 13.6486 15.215 13.5089 15.3744C13.3692 15.5339 13.1974 15.6616 13.005 15.749C12.8126 15.8364 12.604 15.8816 12.3929 15.8816H2.37026C2.1592 15.8816 1.95054 15.8364 1.75814 15.749C1.56573 15.6616 1.39397 15.5339 1.25427 15.3744C1.11457 15.215 1.01012 15.0274 0.947841 14.8242C0.885566 14.6209 0.866894 14.4067 0.893066 14.1956L1.1833 11.8526C1.25079 11.3082 1.51328 10.8075 1.9214 10.4445C2.32952 10.0816 2.85516 9.88137 3.39947 9.88158H3.66067";

export function UserAvatar({ className = "size-[30px]" }) {
  return (
    <div className={`relative shrink-0 ${className}`}>
      <svg
        className="absolute inset-0 size-full"
        fill="none"
        viewBox="0 0 30 30"
      >
        <circle cx="15" cy="15" r="15" fill="#2361F5" />
      </svg>
      <div className="absolute inset-0 flex items-center justify-center">
        <svg
          className="h-[47%] w-[40%]"
          fill="none"
          viewBox="0 0 14.7632 16.7632"
        >
          <path d={USER_HEAD} stroke="white" strokeWidth="1.763" />
          <path
            d={USER_BODY}
            stroke="white"
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth="1.763"
          />
        </svg>
      </div>
    </div>
  );
}

export function AssistantAvatar({ className = "size-[30px]" }) {
  return (
    <div className={`relative shrink-0 ${className}`}>
      <svg
        className="absolute inset-0 size-full"
        fill="none"
        viewBox="0 0 30 30"
      >
        <circle cx="15" cy="15" r="15" fill="#13A149" />
      </svg>
      <div
        className="absolute bg-white"
        style={{
          top: "22%",
          left: "22%",
          width: "56%",
          height: "56%",
          maskImage: `url("${assistantAvatar}")`,
          maskSize: "contain",
          maskRepeat: "no-repeat",
          WebkitMaskImage: `url("${assistantAvatar}")`,
          WebkitMaskSize: "contain",
          WebkitMaskRepeat: "no-repeat",
        }}
      />
    </div>
  );
}
